import styled from 'styled-components';

export const OrderListWrapper = styled.div`
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    .count {
      background: var(--light-primary);
    }
  }
  .ant-tabs-tab-btn {
    .count {
      background: #2c35461a;
    }
  }
  .ant-radio-group {
    width: 100%;
    display: flex;
  }
  .ant-radio-button-wrapper {
    border-radius: ${({ theme }) => theme.borderRadius.button} !important;
    &:before {
      display: none;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }
  .ant-radio-button-wrapper:not(.ant-radio-button-wrapper-checked) {
    background: #ffffff;
    border: 1px solid var(--border-color-light);
    color: var(--color-dark-gray) !important;
    .count {
      background: #2c35461a;
    }
  }
  .ant-radio-button-wrapper-checked {
    background: var(--light-primary) !important;
    color: var(--primary) !important;
    border: 1px solid var(--primary);
    font-weight: 600;
    .count {
      background: #6852d333;
    }
  }
  .ant-radio-group .ant-radio-button-wrapper:not(:first-child) {
    margin-left: 13px;
  }
`;
